import { useFormContext } from 'react-hook-form';
import { ReactComponent as InfoCircle } from 'assets/images/InfoCircle.svg?react';
import RootInput from 'components/Input/RootInput/RootInput';
import { type RootInputProps } from 'components/Input/RootInput/types';
import { getIsRequiredMessage, isMinLength } from 'utils/error';
import { removeSubString } from 'utils/removeSubString';
import { MIN_OFFER_CODE_LENGTH, OFFER_CODE_MASK } from './config';

type Props = Pick<
  RootInputProps,
  'name' | 'label' | 'required' | 'placeholder' | 'containerClassName' | 'inputMode' | 'tooltipText'
> & {
  maskOptions: NonNullable<RootInputProps['maskOptions']>;
};

export const validateOfferCode = (value: string) => {
  const cleanedValue = removeSubString(removeSubString(value, OFFER_CODE_MASK), '-');

  return cleanedValue.length < MIN_OFFER_CODE_LENGTH
    ? isMinLength(MIN_OFFER_CODE_LENGTH)
    : undefined;
};

const OfferCodeInput = (props: Props) => {
  const {
    name,
    label,
    required,
    placeholder,
    maskOptions,
    containerClassName,
    inputMode,
    tooltipText,
  } = props;

  const { control, clearErrors } = useFormContext();

  return (
    <RootInput
      name={name}
      label={label}
      control={control}
      clearErrors={clearErrors}
      required={required}
      placeholder={placeholder}
      maskOptions={maskOptions}
      tooltipText={tooltipText}
      rules={{
        required: {
          value: required,
          message: required ? getIsRequiredMessage(name) : '',
        },
        validate: required ? validateOfferCode : undefined,
      }}
      clearErrorOnTooltipOpen={false}
      onChangeResetTooltip
      externalOnChange={() => {
        clearErrors(name);
      }}
      containerClassName={containerClassName}
      inputMode={inputMode}
      spellCheck={false}
      icon={<InfoCircle />}
    />
  );
};

export default OfferCodeInput;
